export default "__VITE_ASSET__DL0DMPgy__"